import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useSoundPath } from 'hooks/useSoundPath';
import MainSortMarketplace from './MainSortMarketplace';

// Выносим статическую конфигурацию за пределы компонента
const ITEM_CONFIG = {
  'Buy Packs': { to: '/buypacks', label: 'Buy Packs', popupText: 'Purchase additional Card Packs' },
  'Buy Cards': { to: '../marketplace/cards?status=not_owned,for_sale', label: 'Buy Cards', popupText: 'Find and purchase cards from other players in the Marketplace' },
  'Craft Identity': { to: '../crafting/identity', label: 'Craft Identity',},
  'Craft Predicition': { to: '../crafting/prediction', label: 'Craft Predicition' },
  'Sell cards': { component: MainSortMarketplace },
};

const MainSortButtons = ({ data }) => {
  const playSound = useSoundPath();

  const makeSound = useCallback(() => {
    playSound('main');
  }, [playSound]);

  return (
    <>
      {data.map((item) => {
        const config = ITEM_CONFIG[item];

        if (!config) {
          // Лучше не логировать в рендере, но если нужно — оставь
          return null;
        }

        if (config.component) {
          const Component = config.component;
          return <Component key={item} makeSound={makeSound} />;
        }

        return (
          <Link
            key={item}
            to={config.to}
            onClick={makeSound}
            className="gradient-block__search-popup-link"
          >
            {config.label}

            {
              config.popupText && <span>{config.popupText}</span>
            }
          </Link>
        );
      })}
    </>
  );
};

export default MainSortButtons;

// import React, { useCallback } from 'react';
// import { Link } from 'react-router-dom';
// import { useSoundPath } from 'hooks/useSoundPath';
// import MainSortMarketplace from './MainSortMarketplace';

// const MainSortButtons = ({ data }) => {

//   const itemConfig = {
//     'Buy Packs': { to: '/buypacks', label: 'Buy Packs' },
//     'Buy Cards': { to: '../marketplace/cards?status=not_owned,for_sale', label: 'Buy Cards' },
//     'Craft Identity': { to: '../crafting/identity', label: 'Craft Identity' },
//     'Craft Predicition': { to: '../crafting/prediction', label: 'Craft Predicition' },
//     'Sell cards': { component: MainSortMarketplace },
//   };

//   const playSound = useSoundPath();

//   const makeSound = useCallback(() => {
//     playSound('main');
//   }, [playSound])

//   return (
//     <>
//       {data.map((item) => {
//         const config = itemConfig[item];
//         if (!config) {
//           console.warn(`No configuration found for item: ${item} in MainSortButtons.jsx`);
//           return null
//         };

//         if (config.component) {
//           const Component = config.component;
//           return <Component key={item} makeSound={makeSound} />;
//         }

//         return (
//           <Link
//             key={item}
//             onClick={makeSound}
//             to={config.to}
//             className="gradient-block__search-popup-link"
//           >
//             {config.label}
//           </Link>
//         );
//       })}
//     </>
//   );
// }

// export default MainSortButtons;
